/* aur-tabs.js - tab switching for Auralise product tabs (no cart logic). */
if (!customElements.get('aur-tabs')) {
  customElements.define('aur-tabs', class AurTabs extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('[role="tab"]'));
      if (!this.buttons.length) return;
      this.buttons.forEach((btn, i) => {
        btn.addEventListener('click', () => this.select(i));
        btn.addEventListener('keydown', (e) => {
          let next = null;
          if (e.key === 'ArrowRight') next = (i + 1) % this.buttons.length;
          if (e.key === 'ArrowLeft') next = (i - 1 + this.buttons.length) % this.buttons.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = this.buttons.length - 1;
          if (next !== null) {
            e.preventDefault();
            this.select(next);
            this.buttons[next].focus();
          }
        });
      });
    }

    select(index) {
      this.buttons.forEach((btn, i) => {
        const active = i === index;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
        btn.tabIndex = active ? 0 : -1;
        const panel = this.querySelector('#' + btn.getAttribute('aria-controls'));
        if (panel) panel.hidden = !active;
      });
    }
  });
}

/* Theme editor: select the tab whose block is selected */
document.addEventListener('shopify:block:select', (e) => {
  const btn = e.target.closest && e.target.closest('.aur-tabs__btn');
  if (!btn) return;
  const root = btn.closest('aur-tabs');
  if (root && root.select) root.select(root.buttons.indexOf(btn));
});
